import '@sitecore-cloudsdk/events/browser';
import useCookieListener from './useCookieListener';
import { useEffect, useState } from 'react';

export const CONSENT_COOKIE_NAME = 'OptanonConsent';
export const CONSENT_COOKIE_ENABLED = '1';
export const CONSENT_COOKIE_GROUPS = {
  C0001: 'neccessary',
  C0002: 'performance',
  C0003: 'functional',
  C0004: 'marketing',
};
export type ConsentGroups = {
  [key: string]: boolean;
};
export type ConsentCallback = (consentGroups: ConsentGroups) => void;

const useOneTrust = (): {
  consentGroups: ConsentGroups;
} => {
  const { cookie } = useCookieListener(CONSENT_COOKIE_NAME);
  const [consentGroups, setConsentGroups] = useState<ConsentGroups>({});

  useEffect(() => {
    if (cookie) {
      const value = cookie.value;
      const params = new URLSearchParams(value);
      const groups = (params.get('groups') ?? '')
        .split(',')
        .map((group) => group.split(':'))
        .reduce((map, group) => {
          if (group[0] && group[1]) {
            const groupCode = group[0] as keyof typeof CONSENT_COOKIE_GROUPS;
            const groupName = CONSENT_COOKIE_GROUPS[groupCode] ?? groupCode;
            map[groupName] = group[1] === CONSENT_COOKIE_ENABLED;
          }
          return map;
        }, {} as { [key: string]: boolean });
      setConsentGroups(groups);
    }
  }, [cookie]);

  return {
    consentGroups,
  };
};

export default useOneTrust;
